import React, { useRef, useState } from "react";
import ArrowUp from "../../assets/upload.svg";
import RecycleIcon from "../../assets/delete.svg";
import PdfIcon from "../../assets/cv_icon.svg";
import SnackbarComponent from "../Snackbar/Snackbar";
import classes from "./Upload.module.css";

const FileUpload = ({
  onFileSelect,
  acceptedTypes = "image/*",
  maxSize = 2 * 1024 * 1024,
  disabled = false,
  coverLetter = false,
  value = null,
  label = "",
  topLabel,
}) => {
  const fileInputRef = useRef(null);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleFileSelect = (files) => {
    const file = files[0];
    if (file) {
      const isPdf = file.type === "application/pdf";
      const isImage = file.type.startsWith("image/");

      if (!isPdf && !isImage) {
        showSnackbar("Ju lutem ngarkoni një imazh ose PDF.", "error");
        return;
      }

      if (file.size > maxSize) {
        showSnackbar(
          `Skedari duhet të jetë më i vogël se ${Math.round(
            maxSize / (1024 * 1024)
          )}MB.`,
          "error"
        );
        return;
      }

      if (onFileSelect) {
        onFileSelect(file);
      }
    }
  };

  const handleClick = () => {
    if (!disabled && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileInputChange = (e) => {
    const files = Array.from(e.target.files);
    handleFileSelect(files);
  };

  const removeFile = () => {
    if (fileInputRef.current) fileInputRef.current.value = "";
    if (onFileSelect) onFileSelect(null);
  };

  return (
    <div className={classes.container}>
      {topLabel &&
        (() => {
          const match = topLabel.match(/^(.*?)\s*\((.*?)\)$/);
          if (match) {
            const [_, mainText, parenText] = match;
            return (
              <h3 className={classes.h3Title}>
                {mainText} <span className={classes.span}>({parenText})</span>
              </h3>
            );
          }
          return <h3 className={classes.h3Title}>{topLabel}</h3>;
        })()}
      {!value ? (
        <div>
          <button
            type="button"
            className={classes.button}
            onClick={handleClick}
            disabled={disabled}
          >
            <img src={ArrowUp} alt="arrow-up" />
            {label}
          </button>
        </div>
      ) : (
        <div className={classes.secondBtn}>
          <div className={classes.innerContainer}>
            <img src={PdfIcon} alt="pdf-icon" className={classes.icon} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <p className={classes.p}>{value.name}</p>
            </div>
            <button
              type="button"
              onClick={removeFile}
              className={classes.removeFile}
            >
              <img src={RecycleIcon} alt="remove-icon" />
            </button>
          </div>
        </div>
      )}
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedTypes}
        onChange={handleFileInputChange}
        style={{ display: "none" }}
        disabled={disabled}
      />

      <SnackbarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

export default FileUpload;
